var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9592 18.7006L31.3884 4.12048C31.1614 2.83326 30.042 1.92761 28.7787 1.92761C28.6257 1.92761 6.26524 5.85627 6.26524 5.85627C4.82223 6.11074 3.85868 7.48681 4.11314 8.92982L4.36097 10.3354H24.5414C27.1016 10.3354 29.1844 12.4183 29.1844 14.9784V16.8389V21.3526V22.2365L31.8071 21.774C33.2501 21.5196 34.2137 20.1436 33.9592 18.7006Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.1946 23.3424H0V29.4193C0 30.8846 1.18787 32.0724 2.65313 32.0724H24.5414C26.0067 32.0724 27.1946 30.8846 27.1946 29.4193V23.3424ZM7.89882 29.6821H3.38519C2.83575 29.6821 2.39029 29.2366 2.39029 28.6872C2.39029 28.1377 2.83575 27.6923 3.38519 27.6923H7.89882C8.44827 27.6923 8.89372 28.1377 8.89372 28.6872C8.89372 29.2366 8.44834 29.6821 7.89882 29.6821Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.00292969 14.8491H27.1909C27.1234 13.4439 25.9629 12.3253 24.541 12.3253H2.6528C1.23091 12.3253 0.0703984 13.4439 0.00292969 14.8491Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 16.8389H27.1946V21.3525H0V16.8389Z",
    fill: "#00FFF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.dfec119e70b657aed038dda9ff997c22.svg";
export { ForwardRef as ReactComponent };